// Builds a binary OpenCV mask at the detection frame's resolution from a
// detection zone grid mask. The last row/column absorbs the rounding
// remainder so the mask covers the full frame.
export function createZoneMask(
  cv: any,
  gridMask: NonNullable<MotionDetectionZone["gridMask"]>,
  frameRows: number,
  frameCols: number
) {
  const { rows, cols, bits } = gridMask;
  const mask = cv.Mat.zeros(frameRows, frameCols, cv.CV_8UC1);
  const cellHeight = Math.floor(frameRows / rows);
  const cellWidth = Math.floor(frameCols / cols);

  for (let i = 0; i < bits.length; i++) {
    const cellIndex = bits[i];
    const row = Math.floor(cellIndex / cols);
    const col = cellIndex % cols;
    const startY = row * cellHeight;
    const endY = row === rows - 1 ? frameRows : (row + 1) * cellHeight;
    const startX = col * cellWidth;
    const endX = col === cols - 1 ? frameCols : (col + 1) * cellWidth;

    const roi = mask.roi(new cv.Rect(startX, startY, endX - startX, endY - startY));
    roi.setTo(new cv.Scalar(255));
    roi.delete();
  }
  return mask;
}
